var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "membershipFan"
  }, [_c('m-head', {
    ref: "mHeadRef"
  }), _c('div', {
    staticClass: "membershipFan-main"
  }, [_c('div', {
    staticClass: "membershipFan-head",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/fan-bg.jpg`)}) center/100% auto no-repeat`
    }
  }, [_vm._m(0)]), _c('div', {
    staticClass: "membershipFan-list"
  }, _vm._l(_vm.infoList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "membershipFan-item",
      on: {
        "click": function ($event) {
          return _vm.onFanIntroShow(item);
        }
      }
    }, [_c('div', {
      staticClass: "membershipFan-item-main"
    }, [_c('div', {
      staticClass: "membershipFan-item__icon",
      style: {
        background: `url(${require(`@images/${_vm.aiSkin}/fan-icon-bg.png`)}) center/100% auto no-repeat`
      }
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "membershipFan-item-info"
    }, [_c('div', {
      staticClass: "membershipFan-item__title"
    }, [_vm._v(_vm._s(item.label))]), _c('div', {
      staticClass: "membershipFan-lis"
    }, _vm._l(item.children, function (itm, idx) {
      return _c('div', {
        staticClass: "membershipFan-itm"
      }, [_vm._v(_vm._s(itm))]);
    }), 0)])])]);
  }), 0), _c('div', {
    staticClass: "membershipFan-btns"
  }, [_c('div', {
    staticClass: "btn-invite",
    on: {
      "click": _vm.onShare
    }
  }, [_vm._v("Share With Friends")])])]), _c('pop-prompt', {
    attrs: {
      "location": "center",
      "className": "popFanBox",
      "isShadowClick": true,
      "content": "html",
      "show": _vm.popFanIntroShow,
      "isBtnCancel": false,
      "confirmText": "Share With Friends"
    },
    on: {
      "update:show": function ($event) {
        _vm.popFanIntroShow = $event;
      },
      "confirm": _vm.onShare
    }
  }, [_c('div', {
    staticClass: "pop-fan"
  }, [_vm.popFanIntro && _vm.popFanIntro.hasOwnProperty('icon') && _vm.popFanIntro.icon ? _c('div', {
    staticClass: "pop-fan__img",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/fan-icon-bg.png`)}) center/100% auto no-repeat`
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.popFanIntro.icon,
      "alt": ""
    }
  })]) : _vm._e(), _vm.popFanIntro && _vm.popFanIntro.hasOwnProperty('title') && _vm.popFanIntro.title ? _c('div', {
    staticClass: "pop-fan__title"
  }, [_vm._v(_vm._s(_vm.popFanIntro.title))]) : _vm._e(), _c('div', {
    staticClass: "pop-fan__soon"
  }, [_vm._v("Coming soon")]), _vm.popFanIntro && _vm.popFanIntro.hasOwnProperty('intro') && _vm.popFanIntro.intro ? _c('div', {
    staticClass: "pop-fan-list"
  }, _vm._l(_vm.popFanIntro.intro, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "pop-fan-item"
    }, [_vm._v(_vm._s(item))]);
  }), 0) : _vm._e()])]), _c('m-menu')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "membershipFan-head-main"
  }, [_c('div', {
    staticClass: "membershipFan__title"
  }, [_vm._v("FAN RIGHTS CENTER")]), _c('div', {
    staticClass: "membershipFan__sub"
  }, [_c('span', [_vm._v("Earn FanPoints to unlock exclusive rewards")])]), _c('div', {
    staticClass: "membershipFan__intro"
  }, [_vm._v("COMPLETE TASKS TO EARN FANPOINTS AND LEVEL UP SUBSCRIBE FOR FANPOINTS BOOSTS AND VLP PERKS HIGHER LEVEL, MORE BENEFITS")])]);
}];
export { render, staticRenderFns };